import React from 'react';
import {Row, Col} from 'react-bootstrap';
import {useSearchParams} from 'react-router-dom';

export default function HorizontalResponse({label, subquestionNumber, questionResponse}) {
  const results = calculatePercent(questionResponse, subquestionNumber);

  const [params] = useSearchParams();
  const debug_prm = params.get('debug');

  return (
    // onClick={() => openCompareSidebar()} <--- this onClick goes below, commented out per client request
    <>
      <Row className="pt-3 bargraph-container border-bottom">
        <p>
          <u>{label}</u>
        </p>
        <Col sm={4} md={8} lg={10}>
          <div className="horizontal-graph position-relative">
            <div
              className="gradient position-absolute fixed-bottom"
              style={{
                width: `${results.roundedPercent > 0 ? results.roundedPercent : 0}%`,
                height: '1rem',
              }}
            ></div>
          </div>
        </Col>
        <Col>
          <div className="percent">
            {results.roundedPercent > 0 ? `${results.roundedPercent}%` : '---'}
          </div>
          {debug_prm && (
            <>
              <div>{results.yesReduced}</div>
              <div>{results.percent}</div>
            </>
          )}
        </Col>
      </Row>
    </>
  );
}

export function calculateRawPercent(questionResponse, subquestionNumber) {
  return calculatePercent(questionResponse, subquestionNumber).percent;
}

export function calculatePercent(questionResponse, subquestionNumber) {
  let yesResponses;
  let totalResponses;
  let yesTotalWeight = [];
  let totalResponseNumber = [];

  if (questionResponse) {
    yesResponses = questionResponse.filter(ques => ques.response[subquestionNumber] === 1);
    yesResponses.forEach(res => yesTotalWeight.push(parseFloat(res.weight)));
    totalResponses = questionResponse.filter(res => Object.keys(res.response).length > 0);
    totalResponses.forEach(res => totalResponseNumber.push(parseFloat(res.weight)));
  }

  const yesReduced = yesTotalWeight.reduce((prev, curr) => prev + curr, 0);
  const totalReduced = totalResponseNumber.reduce((prev, curr) => prev + curr, 0);

  const percent = totalReduced > 0 ? (yesReduced / totalReduced) * 100 : 0;

  return {
    yesReduced,
    totalReduced,
    percent,
    roundedPercent: Math.round(percent),
  };
}
